import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import { FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { useMemo } from "react";
import MxInputLabel from "../MxInputLabel";
import { styled } from "@mui/material";
import { Csizes } from "@/shared/theme/theme";

function MxRushRadioDuo(props: MxRushRadioDuoProps) {
  const value = useMemo(() => {
    if (!Array.isArray(props.value)) {
      return null;
    }
    if (props.value.length == 0) {
      return null;
    }
    return props.value[0].value;
  }, [JSON.stringify(props.value)]);

  const handleChange = (e: I_GENERIC_ITEMS) => {
    props.onChange({
      target: {
        value: e ? [e] : [],
        name: props.name,
        id: props.id
      }
    });
    props.onBlur && props.onBlur(e);
  };

  return (
    <Content
      container
      alignItems="center"
      data-testid={`${props.id}-rush-radio-duo`}
    >
      <Grid item xs={12} sm="auto">
        <MxInputLabel data-testid={`${props.id}-label`} shrink={false}>
          {props.label}
        </MxInputLabel>
      </Grid>
      <Grid item flex={1} />
      <Grid item xs={12} sm="auto">
        <RadioGroupCustom
          row
          aria-labelledby={props.name + "-id"}
          name={props.name}
          value={value}
          data-testid={`${props.id}-radio-group`}
        >
          {props?.items?.map((item, i) => {
            return (
              <FormControlLabel
                disabled={props.disabled}
                key={i}
                value={item.value}
                onClick={() => handleChange(item)}
                control={<Radio />}
                label={item.label}
                data-testid={`${props.id}-radio-group-item-${item.value}`}
              />
            );
          })}
        </RadioGroupCustom>
      </Grid>
    </Content>
  );
}

export default MxRushRadioDuo;

export interface MxRushRadioDuoProps {
  items: I_GENERIC_ITEMS[];
  label: string;
  name: string;
  value: I_GENERIC_ITEMS[];
  onChange: (e: {
    target: {
      value: I_GENERIC_ITEMS[];
      name: string;
      id: string;
    };
  }) => void;
  onBlur?: (e: any) => void;
  id: string;
  error?: boolean;
  disabled?: boolean;
}

const Content = styled(Grid)(({ theme }) => ({
  border: `1px solid var(--m-border-01)`,
  height: Csizes.input,
  borderRadius: 20,
  position: "relative",
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    height: "auto",
    padding: theme.spacing(1)
  }
}));

const RadioGroupCustom = styled(RadioGroup)(({ theme }) => ({
  position: "absolute",
  top: -5,
  right: 0,
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  alignItems: "center",
  "& .MuiFormControlLabel-label": {
    marginRight: -5,
    color: "var(--m-color-blue-03)",
    fontWeight: 600,
    fontFamily: "var(--ff-inter)",
    fontSize: "var(--fs-placeholder)"
  },
  "& .MuiTypography-root": {
    color: "var(--m-color-blue-03)",
    fontWeight: 600,
    fontFamily: "var(--ff-inter)",
    fontSize: "var(--fs-text-small)"
  },
  [theme.breakpoints.down("sm")]: {
    position: "relative",
    top: "auto",
    right: "auto",
    marginTop: theme.spacing(1),
    width: "100%",
    justifyContent: "space-between"
  }
}));
